/**
 * El acento activo, siempre al día.
 *
 * `useSyncExternalStore` y no un `useState` sembrado al montar: el color se
 * elige desde dos sitios de la misma página —la mascota del Resumen y el menú de
 * usuario— y con una copia propia cada uno, el que no tocaste seguía marcando el
 * color anterior. El estado de verdad no es de ningún componente; está en la
 * cookie y en el atributo de `<html>`, así que lo que hay que hacer es leerlo de
 * ahí y volver a leerlo cuando cambie.
 */
import { useSyncExternalStore } from 'react';
import { DEFAULT_ACCENT, readAccent, subscribeAccent } from './accent';
export function useAccent() {
    /* `readAccent` devuelve una cadena, así que dos lecturas iguales son iguales
       para React y no hay bucle de renderizado. El tercer argumento es para el
       pintado en servidor, que estas aplicaciones no hacen: el de la casa. */
    return useSyncExternalStore(subscribeAccent, readAccent, () => DEFAULT_ACCENT);
}
//# sourceMappingURL=useAccent.js.map